import React from 'react';
import PropTypes from 'prop-types';
import { Popup } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import {
  ConfigGridRow,
  ConfigField,
  ConfigSectionLabel,
  ThresholdToggleGroup,
  ThresholdToggleButton,
  HelpCursor,
  SpeedBinDropdown
} from './styled';

const ConfigurationFields = ({
  localConfig,
  speedBinOptions,
  showSpeedBin,
  onConfigUpdate
}) => {
  const { t } = useTranslation();

  return (
    <ConfigGridRow>
      {showSpeedBin && (
        <ConfigField>
          <ConfigSectionLabel>
            <Popup
              trigger={<HelpCursor>{t('sensors.eventDetection.coupling.speedBin')}</HelpCursor>}
              content={t('sensors.eventDetection.coupling.speedBinHelp')}
              position="top left"
              size="small"
            />
          </ConfigSectionLabel>
          <SpeedBinDropdown
            fluid
            selection
            value={localConfig.speed_bin}
            options={speedBinOptions}
            onChange={(e, data) => {
              const option = speedBinOptions.find(o => o.value === data.value);
              if (!option || !option.disabled) {
                onConfigUpdate('speed_bin', data.value);
              }
            }}
          />
        </ConfigField>
      )}

      <ConfigField>
        <ConfigSectionLabel>
          <Popup
            trigger={<HelpCursor>{t('sensors.eventDetection.coupling.thresholdLevel')}</HelpCursor>}
            content={t('sensors.eventDetection.coupling.thresholdLevelHelp')}
            position="top left"
            size="small"
          />
        </ConfigSectionLabel>
        <ThresholdToggleGroup>
          <Popup
            trigger={(
              <ThresholdToggleButton
                active={localConfig.threshold_level === 'critical'}
                onClick={() => onConfigUpdate('threshold_level', 'critical')}
              >
                {t('sensors.eventDetection.coupling.critical')}
              </ThresholdToggleButton>
            )}
            content={t('sensors.eventDetection.coupling.criticalHelp')}
            position="top center"
            size="small"
          />
          <Popup
            trigger={(
              <ThresholdToggleButton
                active={localConfig.threshold_level === 'warning'}
                onClick={() => onConfigUpdate('threshold_level', 'warning')}
              >
                {t('sensors.eventDetection.coupling.warning')}
              </ThresholdToggleButton>
            )}
            content={t('sensors.eventDetection.coupling.warningHelp')}
            position="top center"
            size="small"
          />
        </ThresholdToggleGroup>
      </ConfigField>
    </ConfigGridRow>
  );
};

ConfigurationFields.propTypes = {
  localConfig: PropTypes.object.isRequired,
  speedBinOptions: PropTypes.array.isRequired,
  showSpeedBin: PropTypes.bool,
  onConfigUpdate: PropTypes.func.isRequired
};

ConfigurationFields.defaultProps = {
  showSpeedBin: false
};

// Memoized because props are now stable (speedBinOptions from useMemo, functions from useCallback)
export default React.memo(ConfigurationFields);
